import { useState, useEffect, useCallback } from "react";
// services
import RocTable from "../services/roc-table";
// types
import type { TableName } from "../types/roc-table";

const useRocTable = <TN extends TableName = TableName>(tableName: TN) => {
	const [loading, setLoading] = useState(() => !RocTable.isTableLoadedAndSynced(tableName));
	const [loaded, setLoaded] = useState(() => RocTable.isTableLoadedAndSynced(tableName));
	const [table, setTable] = useState(() => RocTable.getTableData(tableName));

	const fetchTable = useCallback(() => {
		setLoading(true);
		RocTable.getTable(tableName, (rulesTableList) => {
			setTable(rulesTableList);
			setLoading(false);
			setLoaded(true);
		});
	}, [tableName]);

	useEffect(() => {
		fetchTable();
	}, [fetchTable]);

	return {
		loading,
		loaded,
		table,
		reload: fetchTable,
	} as const;
};

export default useRocTable;
